// Mount the Vod module: hand `createVodModule` a lazy host (`./vod-host`, which holds the app
// imports) instead of a built one. `service-modules.ts` and `service-scopes.ts` take the routes and
// the catalog scopes from HERE, so the module cannot be mounted unregistered. This file must stay
// light: it is in the entry chunk. The HTTP client is not a member: the module reads it from the
// shared registry (`@vnetwork/margarita-core/http`).
import { createVodModule } from '@vnetwork/margarita-vod';

export const vod = createVodModule(() => import('./vod-host').then((m) => m.vodHost));
